// ============================================================================
// The SLA verdict on one shipment — worded, never colour alone (the house rule
// for every overlay on these boards), with the REASON on hover: which rule was
// applied, the cutoff it set, and by how much the shipment made or missed it.
//
// An unjudgeable shipment shows a muted dash, and its tooltip says WHICH input is
// missing — "no verdict" and "on time" must never look alike.
//
// EXCUSED gets a word of its own for the same reason. It counts nowhere as a
// breach, but the shipment behind it may well have landed hours late — showing it
// green would put a false "On time" against a row whose own tooltip says otherwise.
// The tooltip carries both halves: the cutoff it missed, then the escalation that
// forgives it.
// ============================================================================
import { Tag, Tooltip } from "antd";
import React from "react";
import { LogisticsOrderRow } from "../types";
import { BreachState, breachOf } from "./breach";

// Amber for excused, the same warning step the "At risk" figure wears one tab over — a held-back
// judgement, not a clean pass and not a fault.
const TAG: Record<Exclude<BreachState, "unknown">, { color: string; label: string }> = {
  breached: { color: "red", label: "Breached" },
  on_time: { color: "green", label: "On time" },
  excused: { color: "orange", label: "Excused" },
};

const BreachTag: React.FC<{ row: LogisticsOrderRow }> = ({ row }) => {
  const verdict = breachOf(row);

  if (verdict.state === "unknown") {
    return (
      <Tooltip title={verdict.reason}>
        <span style={{ color: "#bbb", cursor: "help" }}>—</span>
      </Tooltip>
    );
  }

  const { color, label } = TAG[verdict.state as Exclude<BreachState, "unknown">];
  return (
    <Tooltip title={verdict.reason}>
      <Tag color={color} style={{ marginInlineEnd: 0, cursor: "help" }}>
        {label}
      </Tag>
    </Tooltip>
  );
};

export default BreachTag;
